import { useEffect, useState } from 'react';
import { useGetPort } from 'api/port';
import { GetPortParams, Port } from 'api/port/port.types';
import { AutocompletePaginationAsync } from 'components/Inputs';
import { FieldValues } from 'react-hook-form';
import { createHandleOnBlur, handleChange } from 'utils/form.utils';

export default function RouteFromAutocomplete<
  TFieldValues extends FieldValues = FieldValues,
>({
  formProps,
  error,
  disabledValues,
}: {
  formProps: TFieldValues;
  error: boolean;
  disabledValues: any[];
}) {
  const { data, loading, getPort } = useGetPort();
  const [options, setOptions] = useState<Port[]>([]);
  const [portParams, setPortParams] = useState<GetPortParams>({
    filterText: '',
    pageNumber: 1,
  });

  useEffect(() => {
    getPort(portParams);
  }, [getPort, portParams]);

  useEffect(() => {
    if (data?.length) {
      const filteredOptions = data
        .filter((port) => port.enabled)
        .map((port) => ({
          ...port,
          disabled: disabledValues.some((disabled) => disabled.id === port.id),
        }));
      setOptions((prev) => {
        const map = new Map(prev.map((p) => [p.id, p]));

        filteredOptions.forEach((port) => {
          map.set(port.id, port);
        });

        return Array.from(map.values());
      });
    }
  }, [data, disabledValues]);

  return (
    <AutocompletePaginationAsync
      {...formProps}
      padding='dense'
      width={280}
      value={formProps.field.value}
      multiple
      error={error}
      loading={loading}
      options={options}
      isOptionEqualToValue={(option, value) => value?.id === option?.id}
      getOptionLabel={(o) => `${o.countryCode} ${o.name}`}
      handleSearchChange={handleChange(setOptions, setPortParams)}
      onChange={(_, data) => formProps.field.onChange(data)}
      onScrollBottom={() =>
        setPortParams((prev: any) => ({
          ...prev,
          pageNumber: prev.pageNumber + 1,
        }))
      }
      onBlur={createHandleOnBlur(
        setOptions,
        setPortParams,
        formProps.field.onBlur,
      )}
      getOptionDisabled={(option) => option.disabled}
    />
  );
}
